import {
	USER_INTERACTION_DATA_ATTRIBUTE,
	USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME,
} from "@shared/constants";
import Label from "@ui/js/components/form/label";
import clsx from "clsx";
import type React from "react";
import { forwardRef } from "react";

interface Props {
	children: React.ReactNode;
	className: string;
	id?: string;
	label?: string;
	message?: string | TrustedHTML;
	state?: "info" | "warning" | "error";
	hasAutoComplete?: boolean;
	[USER_INTERACTION_DATA_ATTRIBUTE]?: string;
}

const Field = forwardRef<HTMLDivElement, Props>(
	(
		{
			children,
			id,
			className = "",
			label,
			message,
			state,
			hasAutoComplete = false,
			...rest
		},
		ref,
	) => {
		return (
			<div
				ref={ref}
				className={clsx(
					{
						form__field: true,
						form__field_state_error: state === "error",
						form__field_state_info: state === "info",
						form__field_state_warning: state === "warning",
					},
					className,
				)}
				{...USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME}
				{...rest}
			>
				{label && <Label htmlFor={id} label={label} />}
				{children}
				{message && (
					<span
						className={clsx(
							{
								form__field__message: true,
							},
							state !== undefined && hasAutoComplete ? "rounded-b-none!" : "",
							className,
						)}
						dangerouslySetInnerHTML={{ __html: message }}
					/>
				)}
			</div>
		);
	},
);

Field.displayName = "Field";

export default Field;
